<template>
  <v-container
    v-if="isAdminLoggedIn"
    class="mt-2"
    fluid
    :class="
      $vuetify.breakpoint.mdAndUp
        ? 'py-5 px-10'
        : '' && $vuetify.breakpoint.smAndUp
        ? 'py-2 px-2'
        : ''
    "
  >
    <PageHeader title="Approve Adverts" />

    <v-row>
      <v-col>
        <v-text-field
          v-model="search"
          flat
          solo-inverted
          hide-details
          prepend-inner-icon="mdi-magnify"
          label="Search"
        ></v-text-field>
        <v-list>
          <template v-for="(item, index) in advertResults">
            <v-list-item
              class="d-flex justify-sm-space-between text-left"
              :class="item.threat ? 'red lighten-4' : null"
              :key="index"
            >
              <v-list-item-avatar
                @click="openLink(item)"
                style="cursor: pointer"
              >
                <v-img
                  v-if="item.logo"
                  :src="faviconImg(item.domain)"
                  @error="setAltImg"
                ></v-img>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title
                  v-text="item.title"
                  @click="openLink(item)"
                  style="cursor: pointer"
                ></v-list-item-title>

                <v-list-item-subtitle
                  v-text="item.category"
                ></v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-content class="hidden-sm-and-down align-self-start">
                <v-list-item-subtitle
                  v-text="item.link"
                  @click="openLink(item)"
                  style="cursor: pointer"
                ></v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-action>
                <v-btn-toggle>
                  <v-btn v-if="item.threat" class="mx-2" x-medium color="red">
                    <v-icon color="white">mdi-shield-bug-outline</v-icon>
                  </v-btn>

                  <v-btn
                    class="mx-2"
                    x-medium
                    color="green"
                    v-if="!item.threat"
                    @click="actionAdvert(item, true)"
                  >
                    <v-icon color="white">mdi-check</v-icon>
                  </v-btn>
                  <v-btn
                    x-medium
                    color="black"
                    @click="actionAdvert(item, false)"
                  >
                    <v-icon color="white">mdi-delete</v-icon>
                  </v-btn>
                </v-btn-toggle>
              </v-list-item-action>
            </v-list-item>

            <v-divider
              v-if="index < advertResults.length - 1"
              :key="index"
            ></v-divider>
          </template>
        </v-list>

        <v-list-item-content class="pl-3">
          <p v-if="advertResults && advertResults.length === 0 && !this.search">
            No Adverts have been added.
          </p>
          <p v-if="advertResults && advertResults.length === 0 && this.search">
            No results found
          </p>
        </v-list-item-content>
      </v-col>
    </v-row>
  </v-container>
  <v-container v-else>
    <v-row>
      <v-col>
        <h1 class="mb-8">
          You are not authorised
        </h1>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import firebase from 'firebase'
//import { addDays } from 'date-fns'
import db from '@/firebase/init'
//const profile = db.collection('profile')
import api from '@/api'
import { AdvertApproved, AdvertUnapproved } from '@/helpers/emails'
import { mapActions } from 'vuex'
import PageHeader from '@/components/layout/PageHeader'

const advertisers = db
  .collection('advertisers')
  .doc('starter')
  .collection('adverts')
import axios from 'axios'
export default {
  name: 'AdvertApprove',
  components: {
    PageHeader
  },
  data() {
    return {
      threat: [],
      search: null,
      initLoaded: false,
      adverts: [],
      checkedAdverts: [],
      selectedAdvertItem: 1,
      advertItems: [
        {
          text: 'Approve advert',
          icon: 'mdi-clock',
          link: '/admin/approve-adverts'
        }
      ]
    }
  },
  created() {
    if (this.checkedAdverts.length === 0) {
      this.getAdverts()
    }
  },
  computed: {
    isAdminLoggedIn() {
      return this.$store.state.auth.permissions.admin
    },
    advertResults() {
      let searchAdverts = this.checkedAdverts.filter(d => d.status === false)
      if (this.search) {
        searchAdverts = searchAdverts.filter(item => {
          return item.title.toUpperCase().includes(this.search.toUpperCase())
        })
      }

      return searchAdverts
    }
  },
  methods: {
    ...mapActions(['getUserProfile']),
    getAdverts() {
      advertisers.onSnapshot(
        querySnapshot => {
          querySnapshot.forEach(doc => {
            if (
              doc.data() &&
              doc.id &&
              doc.data().status === false
              //!doc.data().expiredDate &&
            ) {
              let adverts = {
                ...doc.data(),
                doc_id: doc.id
              }
              this.adverts.push(adverts)
            }
          })
          this.checkUrl(this.adverts)
        },
        error => {
          console.error('Unapproved adverts Error response: ', error)
        }
      )
    },

    async getEmailConfig(item, action) {
      try {
        const emailType = action ? AdvertApproved() : AdvertUnapproved()
        const email = await emailType
        const htmlContent = await email?.html

        if (htmlContent) {
          //Replace [EMAIL_PROMO_URL] with the actual URL
          const modifiedHtml = htmlContent.replace(
            '[EMAIL_PROMO_URL]',
            `${process.env.VUE_APP_HOST}/promo/${item.slug}`
          )

          // get the users email from profile
          const { email: userEmail } = await this.$store.dispatch(
            'getUserProfile',
            item.user_id
          )

          const config = {
            email: userEmail,
            subject: email.subject,
            html: modifiedHtml
          }

          return config
        }
      } catch (error) {
        console.error('Error in getEmailConfig:', error)
        throw error
      }
    },

    async actionAdvert(item, action) {
      if (action) {
        // Business Logic - Remove for now until figured out the requirements for setting the expirey
        // const expiredDate = addDays(
        //   firebase.firestore.Timestamp.now().toDate(),
        //   30
        // )
        const approvedDate = firebase.firestore.Timestamp.now().toDate()

        advertisers.doc(item.doc_id).set({
          ...item,
          status: action,
          //expiredDate,
          approvedDate
        })
      } else {
        advertisers.doc(item.doc_id).delete()
      }

      // get the users email from profile
      const { email } = await this.$store.dispatch(
        'getUserProfile',
        item.user_id
      )
      // set advertise to true which shows the profile
      //profile.doc(item.user_id).set({ advertiser: action }, { merge: true })

      // Call the API to add admin role
      await api.setPermissions(email, {
        advertiser: action
      })

      const indexOfObject = this.checkedAdverts.findIndex(object => {
        return object.doc_id === item.doc_id
      })
      this.checkedAdverts.splice(indexOfObject, 1)

      // Send welcome email
      const emailConfig = await this.getEmailConfig(item, action) // Wait for getEmailConfig to complete
      if (emailConfig) {
        await api.sendEmail(emailConfig) // Send email
      }
    },
    setAltImg($event) {
      $event.target.src = './img/linkbook-logo.png'
    },
    async checkUrl(adverts) {
      if (!adverts || adverts.length === 0) {
        return
      }

      const urls = adverts.map(data => data.link).filter(url => url)

      if (urls.length === 0) {
        this.checkedAdverts = this.adverts
        return
      }

      const batchSize = 50
      const apiKey = process.env.VUE_APP_GOOGLE_SAFEBROWSE_KEY

      try {
        for (let i = 0; i < urls.length; i += batchSize) {
          const batchUrls = urls.slice(i, i + batchSize)
          const urlParams = batchUrls
            .map(url => `urls=${encodeURIComponent(url)}`)
            .join('&')
          const v5Url = `https://safebrowsing.googleapis.com/v5alpha1/urls:search?${urlParams}&key=${apiKey}`

          const result = await axios.get(v5Url)

          if (result.data.threats && result.data.threats.length > 0) {
            const threatMap = new Map()
            result.data.threats.forEach(threat => {
              threatMap.set(threat.url, threat.threatTypes)
            })

            this.adverts.forEach(advert => {
              if (threatMap.has(advert.link)) {
                advert.threat = true
                advert.threatTypes = threatMap.get(advert.link)
              }
            })
          }
        }

        this.checkedAdverts = this.adverts
        this.adverts = []
      } catch (error) {
        console.error('Safe Browsing API error:', error)
        this.checkedAdverts = this.adverts
        this.adverts = []
      }
    },

    openLink: function(item) {
      if (!item.threat) {
        window.open(item.link, '_blank')
      }
    },
    faviconImg(domain) {
      return 'https://' + domain + '/favicon.ico'
    },
    Funcioncall(name) {
      if (name) {
        this[name]()
      }
    }
  }
}
</script>
